module.exports = __webpack_public_path__ + "img/M.ef2c3404.jpg";